const DEFAULT_BASE_URL = '/api'
const rawBaseUrl = (import.meta as any).env?.VITE_API_BASE_URL?.trim()

export function resolveBaseUrl(): string {
  if (!rawBaseUrl) {
    return DEFAULT_BASE_URL
  }

  return rawBaseUrl
}

export const BASE_URL = resolveBaseUrl()